<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<fleet-empty-layout *ngIf="layout === 'empty'"></fleet-empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->

<fleet-main-layout *ngIf="layout === 'fleet'"></fleet-main-layout>

<fleet-flex-layout *ngIf="layout === 'flex'"></fleet-flex-layout>

<fleet-traveller-layout *ngIf="layout === 'traveller'"></fleet-traveller-layout>
<fleet-kiosk-layout *ngIf="layout === 'kiosk'"></fleet-kiosk-layout>
<fleet-native-app-webview-layout *ngIf="layout === 'native-app'"></fleet-native-app-webview-layout>
<!--
  -----------------------------------------------------------------------------------------------------
  --
>
  <!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- <div
    class="fixed flex items-center justify-center right-0 w-10 h-10 shadow-lg rounded-l-lg z-999 cursor-pointer bg-red-600 bg-opacity-90 print:hidden"
    style="top: 275px"
    (click)="settingsDrawer.toggle()">
    <mat-icon
        class="icon-size-5 text-white animate-spin-slow"
        [svgIcon]="'heroicons_solid:cog'"></mat-icon>
</div> -->

<div aria-live="assertive"
  class="fixed inset-0 z-9999 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
  <fleet-onscreen-notification></fleet-onscreen-notification>
</div>
